import "@styles/components.scss";
import "@styles/icomoon.css";

export default function Badge(props) {
    const { deck, disabled } = props;

    // ========================= Render Function =================================
    return (
        <div className="badge">
            <div
                className="ring"
                title={`${deck.content.name}: ${deck.content.description} - ${deck.points} Points`}
                style={{
                    background: disabled
                        ? "#666666"
                        : `radial-gradient(${deck.content.bgColor}, ${deck.content.bgColor}aa)`,
                }}
            >
                <div
                    className="surface"
                    style={{
                        background: disabled
                            ? "#454545"
                            : `radial-gradient(${deck.content.fgColor}66, ${deck.content.fgColor})`,
                    }}
                >
                    <i
                        className={`icon icm ${deck.content.icon} icon`}
                        style={{
                            color: disabled
                                ? "#333333"
                                : deck.content.textColor,
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
